/**
 * The WATCHED board's props, with the notation's local browsing applied — the
 * watch twin of the core's `boardPropsAtPly` (M4 §3).
 *
 * Lane-side rather than in the shared core because it is a COMPOSITION of two
 * things the core already owns (`selectWatchBoardProps` and `fenAtPly`) and the
 * browsing state it applies (`useV2Ui.viewPly`) is this lane's UI state; the core
 * has no browsing concept of its own.
 *
 * The shape is the LIVE one (`BoardProps`) so `BoardFrame`'s View, and therefore
 * the Chessboard, takes the same object either way. A spectator never moves, so
 * `disabled` is always true and `arePremovesAllowed` always false — and
 * `restrictedPiece` is '' because the touch-piece rule is about MY pieces.
 */
import type {BoardProps} from '@/Store/liveGame/selectors';
import {fenAtPly, selectWatchBoardProps} from '@/Store/liveGame/selectors';
import type {LiveGameState} from '@/Store/liveGameStore';
import {START_FEN} from '@/Store/liveGame/state';

export const watchBoardPropsAtPly = (
  s: LiveGameState,
  viewPly: number | null,
): BoardProps => {
  const live = selectWatchBoardProps(s);
  const base: BoardProps = {
    position: live.position,
    boardOrientation: live.boardOrientation,
    disabled: true,
    lastMoveFen: live.lastMoveFen,
    restrictedPiece: '',
    arePremovesAllowed: false,
  };
  if (viewPly === null || viewPly >= s.watch.moves.length) {
    return base;
  }
  return {
    ...base,
    position: fenAtPly(s.watch.startFen || START_FEN, s.watch.moves, viewPly),
    // the highlight belongs to the live position, not to a browsed one
    lastMoveFen: null,
  };
};

export default watchBoardPropsAtPly;
